<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <date-picker
            is-expanded
            :columns="$screens({ default: 1, lg: 3 })"
            v-model="range"
            is-range
          />
        </div>
        <div class="col-lg-3">
          <div class="card bookCard text-center">
            <h3 class="card-header">Your Holiday</h3>
            <div class="card-body">
              <p class="card-title">
                {{ this.range.start | moment("ddd D MMM YY") }} for
                {{ this.searchResults.days }} nights
                <!-- {{for 3 Nights}} -->
              </p>

              <p class="card-text propPrice">
                <span class="priceAt"
                  ><span class="price-pre">£</span
                  >{{ this.searchResults.price }}</span
                >
              </p>
              <p class="card-text bookP">
                <a
                  class="bookNowBtn button green"
                  :href="this.searchResults.online_deep_link"
                  target="book"
                  >Book Now</a
                >
              </p>
              <p class="card-text cancelP">
                <a class="resetDates slowScroll" href="#Availability"
                  >Check Other Dates</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- <pre>
    {{ searchResults }}
    {{ range.start | moment }}
    {{ range.end | moment }}
    </pre> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import Calendar from 'v-calendar/lib/components/calendar.umd'
// import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  data() {
    return {
      range: {
        start: new Date(2021, 11, 26),
        end: moment().add(3, "days").format("YYYY, MM, D"),
      },
      // from_date: "2022-01-05",
      // range: {
      //   start: moment(this.searchResults.from_date).format("YYYY, M, D"),
      //   end: moment(this.start)
      //     .add(this.searchResults.days, "days")
      //     .format("YYYY, M, D"),
      // },
      searchResults: {},
    };
  },
  components: {
    // Calendar,
    // DatePicker,
  },
  created() {
    this.getSearchResults();
  },
  methods: {
    getSearchResults() {
      const cached = localStorage.getItem("atbSearchData");
      if (!cached) return;

      const parsed = JSON.parse(cached);
      if (!parsed?.from_date) return;

      this.searchResults = parsed;
      this.range.start = moment(parsed.from_date).format("YYYY, MM, D");
      this.range.end = moment(parsed.from_date)
        .add(parsed.days || 0, "days")
        .format("YYYY, MM, D");
    },
  },
  computed: {},
  watch: {
    getSearchResults: function (newValue) {
      this.searchResults = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>